export default "__VITE_ASSET__DoUKN27n__"